var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('section',{staticClass:"container"},[_c('app-grid'),_c('div',{attrs:{"id":"sidebar"}},[_c('h3',[_vm._v(_vm._s(_vm.$t("form.title")))]),_c('app-form'),_c('app-code')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }